var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetaColor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1620_1691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7541 0.135132L17.1523 8.90838L19.2975 3.73254L28.7541 0.135132Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.96826 0.135132L13.4771 8.99217L11.4382 3.73254L1.96826 0.135132Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5805 20.4709L21.4902 25.29L28.1009 27.1414L30.0017 20.5763L24.5805 20.4709Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.745117 20.5763L2.63538 27.1414L9.246 25.29L6.15574 20.4709L0.745117 20.5763Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87422 12.3269L7.03174 15.1621L13.5946 15.4594L13.3636 8.27811L8.87422 12.3269Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8515 12.3266L17.3037 8.19408L17.1523 15.4592L23.7046 15.1619L21.8515 12.3266Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24609 25.2898L13.1886 23.3302L9.78238 20.6248L9.24609 25.2898Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5371 23.3305L21.4902 25.29L20.9406 20.625L17.5371 23.3305Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4902 25.29L17.5371 23.3305L17.853 25.9549L17.8159 27.0576L21.4902 25.29Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24609 25.29L12.9204 27.0576L12.8965 25.9549L13.1886 23.3305L9.24609 25.29Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24603 25.29L9.8062 20.4709L6.15576 20.5763L9.24603 25.29Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9307 20.471L21.4908 25.2901L24.5811 20.5764L20.9307 20.471Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7046 15.1626L17.1523 15.46L17.7577 18.8925L18.7267 16.8249L21.0577 17.906L23.7046 15.1626Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68926 17.906L12.0202 16.8249L12.9786 18.8925L13.5946 15.46L7.03174 15.1626L9.68926 17.906Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03174 15.1626L9.78218 20.625L9.68926 17.906L7.03174 15.1626Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0572 17.906L20.9404 20.625L23.7041 15.1626L21.0572 17.906Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5949 15.4598L12.979 18.8924L13.7463 22.9385L13.9215 17.6086L13.5949 15.4598Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1519 15.4599L16.8359 17.5979L16.9766 22.9386L17.7572 18.8925L17.1519 15.4599Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9891 18.3556L9.69971 17.3691L12.0201 16.288L12.9891 18.3556Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7573 18.3556L18.7264 16.288L21.0573 17.3691L17.7573 18.3556Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7581 18.8916L16.9775 22.9377L17.5377 23.3296L20.9413 20.6241L21.0581 17.9051L17.7581 18.8916Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68945 17.9051L9.78237 20.6241L13.1886 23.3296L13.7461 22.9377L12.9788 18.8916L9.68945 17.9051Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.816 27.0573L17.8532 25.9546L17.5611 25.6924H13.1647L12.8965 25.9546L12.9204 27.0573L9.24609 25.2897L10.5284 26.3573L13.1302 28.1979H17.5957L20.208 26.3573L21.4903 25.2897L17.816 27.0573Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5367 23.3307L16.9765 22.9388H13.7456L13.188 23.3307L12.896 25.9552L13.1641 25.693H17.5606L17.8526 25.9552L17.5367 23.3307Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2451 9.47881L30.2353 4.63541L28.7539 0.135269L17.5371 8.61121L21.8513 12.3275L27.9495 14.1438L29.3035 12.5411L28.7194 12.114L29.6513 11.2464L28.9291 10.6761L29.861 9.9518L29.2451 9.47881Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.500488 4.63549L1.49075 9.47889L0.86155 9.95187L1.79606 10.6762L1.08456 11.2465L2.01642 12.1141L1.43235 12.5411L2.77305 14.1439L8.87394 12.3276L13.1881 8.61129L1.96863 0.135345L0.500488 4.63549Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9493 14.1445L21.851 12.3282L23.7041 15.1634L20.9404 20.6258L24.5803 20.5771H30.0015L27.9493 14.1445Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87432 12.3282L2.77344 14.1445L0.745117 20.5771H6.15574L9.78229 20.6258L7.03184 15.1634L8.87432 12.3282Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1527 15.4597L17.5377 8.61082L19.3111 3.73228H11.4395L13.189 8.61082L13.5952 15.4597L13.7359 17.6219L13.7465 22.9383H16.9775L17.0014 17.6219L17.1527 15.4597Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1620_1691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 28.3333,
    fill: "white",
    transform: "translate(0.368164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaColor);
export default __webpack_public_path__ + "static/media/meta-color.4452db6d9be6ecef33ff9e8a9eaa3324.svg";
export { ForwardRef as ReactComponent };